import { PUTTS_PER_ROUND, type PuttMark } from './tileViewModel'

/**
 * The putt callout (B34): a slim pill under the corner capsule that names the
 * putt that just landed — "Putt 2 of 3 · Missed" — and, on the third, the
 * round's verdict ("Two in"). Owner: "small minimal way so it's not taking up
 * too much space as we already have all this stuff mostly in the capsule".
 */
export type CalloutKind = 'holed' | 'missed' | 'verdict'

export interface CalloutView {
  putt: number
  kind: CalloutKind
  mark: PuttMark
  /** The count option key of the putts so far (`IN0`..`IN3`), the verdict's label. */
  countKey: string
}

/** In, hold and out, ms — the stylesheet's `birdie-callout` keyframe runs this long. */
export const CALLOUT_MS = 1600

export function calloutForMarks(marks: readonly PuttMark[]): CalloutView | undefined {
  const putt = marks.length
  if (putt === 0) return undefined
  const mark = marks[putt - 1] as PuttMark
  let holed = 0
  for (const seen of marks) if (seen === 'holed') holed++
  return {
    putt,
    kind: putt >= PUTTS_PER_ROUND ? 'verdict' : mark,
    mark,
    countKey: `IN${holed}`
  }
}
